var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isConfigSuccess)?[_c(_vm.isMobile ? 'MobileHome' : 'PcHome',{tag:"component",staticClass:"component"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }